import Vue from 'vue';
import Component from 'vue-class-component';
import { SettingsUsersStore } from "@/store/modules/Settings/User"
import {IUsers, IUsersItems} from "@/entity/Settings/Users.types";

@Component
export class SettingsUserMix extends Vue {
    get users() : IUsers | null {
        return SettingsUsersStore.users
    }
    get user(): IUsersItems | null {
        return SettingsUsersStore.usersItems
    }
}

